import { List } from "immutable";

import { ContentId } from "../../../../models/state/contents/content/Content";
import { ModuleId } from "../../../../models/state/modules/Modules";
import Section, {
  SectionId
} from "../../../../models/state/sections/section/Section";

export function getId(section: Section) {
  return section?.id;
}

export function getParentId(section: Section) {
  return section?.parentId;
}

export function getTitle(section: Section) {
  return section?.title;
}

export function doesSectionHaveSequentialContent(section: Section) {
  return !!section?.hasSequentialContent;
}

export function getSectionIds(section: Section): List<SectionId> {
  return section?.sectionIds ?? emptyList;
}

export function getContentIds(section: Section): List<ContentId> {
  return section?.contentIds ?? emptyList;
}

export function getExerciseContentIds(section: Section): List<ContentId> {
  return section?.exerciseContentIds ?? emptyList;
}

export function getModuleIds(section: Section): List<ModuleId> {
  return section?.moduleIds ?? emptyList;
}

export function isLeafSection(section: Section): boolean {
  return getSectionIds(section).size === 0;
}

export function getSectionExamQuestionsCount(section: Section) {
  return section?.examQuestionsCount;
}

export function doesSectionHaveExamQuestions(section: Section) {
  return !!getSectionExamQuestionsCount(section);
}

const emptyList = List([]);
